<template>
  <a-layout class="index animated fadeIn">
    <a-card :bordered="false">
      <div class="m-b-20 s_flex_bian_c">
        <div>
          <span class="mr15">
            <a-button type="primary" v-has:redCreate="()=> {$router.push('/assets/red/create?type=add')}">
              <PlusOutlined />新建红包
            </a-button>
          </span>
        </div>
      </div>
      <a-form ref="form" :model="search" :style="{ 'marginBottom': '20px' }" :initialValues="search" :onFinish="pageSearchChange" layout="inline">
        <a-form-item label name="keywords">
          <a-input-group compact :style="{ width: '360px' }">
            <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
              <a-select-option value="author">发放者</a-select-option>
              <a-select-option value="description">红包说明</a-select-option>
              <a-select-option value="use_description">使用说明</a-select-option>
              <a-select-option value="amount">红包余额</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="创建日期" name="time">
          <a-range-picker v-model:value="time" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" @change="onChange" />
        </a-form-item>
        <a-form-item label="状态" name="bonus_status">
          <a-select v-model:value="search.bonus_status" :style="{ width: '140px' }" placeholder="全部">
            <a-select-option value>全部</a-select-option>
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="红包类型" name="bonus_type">
          <a-select v-model:value="search.bonus_type" :style="{ width: '140px' }" placeholder="全部">
            <a-select-option value>全部</a-select-option>
            <a-select-option :value="1">微信红包</a-select-option>
            <a-select-option :value="2">企业零钱红包</a-select-option>
            <a-select-option :value="3">累计红包</a-select-option>
            <a-select-option :value="4">小程序红包</a-select-option>
            
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType="submit">搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination="false" :loading="listLoading" bordered :columns="columns" :data-source="data" :scroll="{ x: 'max-content'}" class='tableFixBox'>
        <template v-slot:status="{ record }">
          <p>{{ record.status ? '正常' : '禁用' }}</p>
        </template>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link">
              操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a v-has:redEdit="()=> {$router.push({ path:'/assets/red/edit', query:{type:'edit',id:record.id} })}" href="javascript:;">修改</a>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:redStatus="()=>moneyDisable(record)" href="javascript:;">{{ record.is_money_valid ? '禁用' : '启用' }}</a>
                </a-menu-item>
                <a-menu-item  v-if="record.relation==1">
                  <a v-has:redRelation="()=>openAssociate(record.id)" href="javascript:;">红包关联</a>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:redDel="()=>delRed(record)" href="javascript:;">删除</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{ marginTop: '10px', textAlign: 'right' }" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
    </a-card>
  </a-layout>
  <!-- 红包关联 -->
  <a-modal  :keyboard="false" title="选择分组" centered v-model:visible="associateVisible" destroyOnClose  :width="1000">
     <a-table :pagination="false" :loading="listLoading" bordered :columns="associateCloumns" :data-source="associateList">
      </a-table>
      <a-pagination :style="{ marginTop: '10px', textAlign: 'right' }" show-size-changer show-quick-jumper :current="associateSearch.page" :page-size="associateSearch.limit" :total="associateTotal" @change="associatePageCurrentChange" @showSizeChange="associatePageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-modal>
</template>
<script>
import {
  DownOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs, h, createVNode } from "vue";
import { message } from "ant-design-vue";
import {
  delBonus,
  statusBonus,
  getBonusList,
  getBonusRelationList,
} from "@/api/red";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 8,
  status: "",
  key_type: "author",
  start_time: "",
  end_time: "",
  keyword: "",
  bonus_status: "",
  bonus_type: "",
};
let defInvite = {
  name: "",
  dealer_sn: "",
  level_id: undefined,
};
//红包关联
const useAssociate = () => {
  // 搜索字段

  const associateSearch = ref({ page: 1, limit: 10 });
  // 弹窗
  const associateVisible = ref(false);
  // 数据列表
  const associateList = ref([]);
  // 列表总数
  const associateTotal=ref(0)
  // 获取列表
  const getAssociateLise = async (id) => {
    let result = await getBonusRelationList({ ...associateSearch, id })
      .then((res) => res.data)
      .catch((error) => error);
    if (iscode(result)) {
      associateList.value = result.data.data;
      associateTotal.value=result.data.total
    }
  };
  // 分页当前页切换
  const associatePageCurrentChange = (page, pageSize) => {
    associateSearch.value.page = page;
    getAssociateLise();
  };
  // 分页当前页显示多少条切换
  const associatePageSizeChange = (current, limit) => {
    associateSearch.value.page = 1;
    associateSearch.value.limit = limit;
    getAssociateLise();
  };
  const openAssociate = (id) => {
    associateSearch.value.page=1
    associateVisible.value = true;
    getAssociateLise(id);
  };
  const associateCloumns=[
      {
        title: "活动名称/会员卡名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "关联模块",
        dataIndex: "type",
        key: "type",
      },
  ]
  return {
    associateSearch,
    associateVisible,
    associateList,
    associateTotal,
    associateCloumns,
    openAssociate,
    getAssociateLise,
    associatePageCurrentChange,
    associatePageSizeChange,
  };
};
export default {
  components: { DownOutlined, PlusOutlined },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    let form = ref(defInvite);
    let formLink = ref({
      name: "总部",
      parent_dealer_id: 0,
    });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      list: [],
      listLoading: false,
      time: [],
      total: 1,
      level: null,
    });
    let columns = [
      {
        title: "红包ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "红包类型",
        dataIndex: "type",
        key: "type",
        customRender: ({ record }) => {
          return record.bonus_type == 1
            ? "微信红包"
            : record.bonus_type == 2
            ? "企业零钱红包" 
            : record.bonus_type == 3
            ? "累计红包"
            :"小程序红包";
        },
      },
      {
        title: "红包金额",
        dataIndex: "amount",
        key: "amount",
      },
      {
        title: "发放者",
        dataIndex: "author",
        key: "author",
      },
      {
        title: "红包说明",
        dataIndex: "description",
        key: "description",
      },
      {
        title: "使用说明",
        dataIndex: "use_description",
        key: "use_description",
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "状态",
        key: "is_money_valid",
        customRender: ({ record }) => {
          return record.is_money_valid == 1 ? "启用" : "禁用";
        },
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        width: 100,
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    // 禁用红包
    const moneyDisable = (e) => {
      $Modal.confirm({
        centered: true,
        title: e.is_money_valid ? "禁用红包" : "启用红包",
        icon: createVNode(ExclamationCircleOutlined),
        content: h("div", {}, [
          h("p", e.is_money_valid ? "确定要禁用吗？" : "确定要启用吗？"),
        ]),
        onOk: async () => {
          let res = await statusBonus({ id: e.id }).then((res) => res.data);
          if (iscode(res)) {
            message.success(res.msg);
            initData(search.value);
          } else {
            message.error(res.msg);
          }
        },
      });
    };
    //删除红包
    const delRed = (e) => {
      $Modal.confirm({
        centered: true,
        title: "红包删除",
        content: "删除后该红包将无法恢复，您确定要删除该红包吗？",
        onOk: async () => {
          let res = await delBonus({ id: e.id }).then((res) => res.data);
          if (iscode(res)) {
            message.success(res.msg);
            initData(search.value);
          } else {
            message.error(res.msg);
          }
        },
      });
    };

    const initData = async (values) => {
      state.listLoading = true;
      data.value = [];
      try {
        let res = await getBonusList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      initData(search.value);
    });
    const inputSelect = (e) => {
      search.value.keywords = "";
    };
    // 红包关联
    const {
      associateSearch,
      associateVisible,
      associateList,
      associateTotal,
      associateCloumns,
      openAssociate,
      getAssociateLise,
      associatePageCurrentChange,
      associatePageSizeChange,
    } = useAssociate();

    return {
      ...toRefs(state),
      search,
      formLink,
      form,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      moneyDisable,
      delRed,
      inputSelect,
      associateSearch,
      associateVisible,
      associateList,
      associateTotal,
      associateCloumns,
      openAssociate,
      getAssociateLise,
      associatePageCurrentChange,
      associatePageSizeChange,
    };
  },
};
</script>